import { FreeBusyStatus, UNKNOWN_OPTION, WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { DailyFilter } from './types';

function isWorkingElsewhere(option: WhereaboutsOption): boolean {
  return option.id !== UNKNOWN_OPTION.id
    && option.status !== 'OFFICE'
    && option.freeBusyStatus !== FreeBusyStatus.OOF;
}

// Single source of truth for the day/week filter chips: "working elsewhere"
// means anything that isn't unknown, in the office, or out of office.
export function matchesDailyFilter(filter: DailyFilter, amOption: WhereaboutsOption, pmOption: WhereaboutsOption): boolean {
  if (!filter) return true;
  if (filter === 'office') {
    return amOption.status === 'OFFICE' || pmOption.status === 'OFFICE';
  }
  if (filter === 'outOfOffice') {
    return amOption.freeBusyStatus === FreeBusyStatus.OOF || pmOption.freeBusyStatus === FreeBusyStatus.OOF;
  }
  if (filter === 'workingElsewhere') {
    return isWorkingElsewhere(amOption) || isWorkingElsewhere(pmOption);
  }
  return true;
}
